export default []
    .concat(require('./Admin'), require('./AdventureTravel'), require('./BaseRoutes'), 
// require('./Checkout'),
require('./Community'), require('./Errors'), require('./Groups'), require('./HubShare'), require('./JAlert'), require('./Messages'), require('./Page'), require('./Profile'), require('./Research'), require('./UserAuth'), require('./Webinars'), require('./ResourceCenter'));



// WEBPACK FOOTER //
// ./~/ts-loader??ref--3!./src/js/Router/Routes/index.ts